/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
import axios from 'axios';
import SwalToast from '../components/Common/SwalToast';
import { API_ENDPOINTS } from '../const/ApiEndpoints';
import { store, persistor } from '../state/store/Store';

export const getCookieValue = (name) => {
  const cookies = document.cookie ? document.cookie.split(';') : [];
  for (let i = 0; i < cookies.length; i += 1) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith(`${name}=`)) {
      return decodeURIComponent(cookie.substring(name.length + 1));
    }
  }
  return '';
};

const logout = async () => {
  try {
    store.dispatch({
      type: 'app/setAuth',
      payload: {
        isLoggedIn: false,
        token: null,
        user: null,
        refresh: null,
        username: null,
        org: null,
      },
    });
    store.dispatch({
      type: 'app/setPanelNavigation',
      payload: { panelNavigation: '' },
    });
    if (persistor) {
      persistor.pause();
      try {
        await persistor.purge();
      } catch (purgeError) {
        console.log(purgeError);
      }
    }
    localStorage.clear();
    sessionStorage.clear();
    window.location.reload();
  } catch (e) {
    console.error('Logout failed while clearing persisted/session state.', e);
  }
};
const intializeAxios = () => {
  const headersCommonOptions = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };

  const showLoaderEvent = new Event('showLoader', { bubbles: true });
  const hideLoaderEvent = new Event('hideLoader', { bubbles: true });
  let numberOfApiCallsPending = 0;
  axios.defaults.baseURL = API_ENDPOINTS.DJANGO_SERVER_ADDRESS;
  axios.defaults.headers.common = headersCommonOptions;
  axios.interceptors.request.use((req) => {
    // `req` is the Axios request config, so you can modify
    // the `headers`.
    const { token, org } = store.getState().app.auth;
    const csrfToken = getCookieValue('csrftoken');
    if (['post', 'put', 'patch', 'delete'].includes(req.method)) {
      req.headers['X-CSRFToken'] = csrfToken;
    }
    if (token && !req.url.startsWith('https://')) {
      req.headers.Authorization = `Bearer ${token}`;
    }
    if (org) {
      req.headers.org = org;
    }
    numberOfApiCallsPending += 1;
    if (
      ('loader' in req && req.loader === false) ||
      req?.data?.loader === false
    ) {
      document.dispatchEvent(hideLoaderEvent);
    } else {
      document.dispatchEvent(showLoaderEvent);
    }
    return req;
  });

  axios.interceptors.response.use(
    (response) => {
      numberOfApiCallsPending -= 1;
      if (numberOfApiCallsPending === 0) {
        setTimeout(() => {
          document.dispatchEvent(hideLoaderEvent);
        }, 400);
      }
      // Visible only when authenticated using the master password
      if (response?.data?.MPMsg) {
        SwalToast({
          icon: 'warning',
          title: response?.data?.MPMsg,
        });
      }
      return response;
    },
    async (error) => {
      numberOfApiCallsPending -= 1;
      if (numberOfApiCallsPending === 0) {
        setTimeout(() => {
          document.dispatchEvent(hideLoaderEvent);
        }, 400);
      }
      if (error.config.url === API_ENDPOINTS.REFRESH_TOKEN) {
        logout();
        return Promise.reject(error);
      }
      if (error.response?.status === 401 && numberOfApiCallsPending >= 0) {
        if (error.response?.data?.Msg) {
          SwalToast({
            icon: 'error',
            title: error.response?.data?.Msg,
          });
        } else {
          SwalToast({
            icon: 'warning',
            title: error.response?.data?.detail,
          });
          numberOfApiCallsPending = 0;
        }
        setTimeout(() => {
          logout();
        }, 1000);
        return Promise.reject(error);
      }
      if (error.response?.data?.Msg) {
        SwalToast({
          icon: 'error',
          title: error.response?.data?.Msg,
        });
      }
      return Promise.reject(error);
    }
  );
};

export const ApiUtils = {
  intializeAxios,
};

